<template>
	<div
		class="booking-calendar-desktop"
		:class="{ 'nk-force-disable': loading.doingBooking }"
	>
		<BookingCalendarWeekDesktop v-if="ui.calendarViewType == 'week'" />
		<BookingCalendarMonth v-if="ui.calendarViewType == 'month'" />
		<ShowNextAvailableTimeButton />
	</div>
</template>

<script>
import BookingCalendarWeekDesktop from "./BookingCalendarWeekDesktop.vue";
import BookingCalendarMonth from "./BookingCalendarMonth.vue";
import ShowNextAvailableTimeButton from "./ShowNextAvailableTimeButton.vue";
import { mapState, mapGetters } from "vuex";
export default {
	components: {
		BookingCalendarWeekDesktop,
		BookingCalendarMonth,
		ShowNextAvailableTimeButton,
	},
	computed: {
		...mapState(["ui"]),
		...mapGetters(["loading"]),
	},
};
</script>